import { motion } from "framer-motion";
import { EASE, MaskedLines } from "@/components/Reveal";

export function PageHeader({ overline, lines, description }) {
  return (
    <section className="relative overflow-hidden pb-14 pt-36 lg:pb-20 lg:pt-48">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="absolute -top-24 right-[-10%] h-[360px] w-[360px] rounded-full bg-brand/15 blur-[130px]" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="font-mono text-xs uppercase tracking-[0.25em] text-brand"
        >
          {overline}
        </motion.p>
        <h1 className="mt-5 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
          <MaskedLines lines={lines} />
        </h1>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5, ease: EASE }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-muted2 md:text-lg"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
